import { render, staticRenderFns } from "./collapseCard.vue?vue&type=template&id=4461467c&scoped=true&"
import script from "./collapseCard.vue?vue&type=script&lang=js&"
export * from "./collapseCard.vue?vue&type=script&lang=js&"
import style0 from "./collapseCard.vue?vue&type=style&index=0&id=4461467c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4461467c",
  null
  
)

export default component.exports